import { Injectable, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
  Http
} from "@angular/http";
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
@Injectable()
export class DataService implements OnInit {
  DisplayName: string = environment.DisplayName;
  UserName: string = "";
  UserUrl: string = environment.UserUrl;
  LogoUrl: string = environment.LogoUrl;
  ComponentName: string;
  Settings: any = {};
  ReportPermission: any = {}
  Access: any = {}
  NgSettings: any = {};
  resetSettings: boolean = true;
  lNameTemp: string;
  ItemDetails: any;
  SupplierDetails: any;
  RestItemDetails: any;
  RestItemComboDetails: any;
  private start: number = 0
  private total: number = 0;
  ShowStockQtyInItemlist: boolean = false
  constructor(private auth: AuthenticationService, private http: Http, private router: Router) {


  }
  ngOnInit() {

    this.LoadData();
    this.resetSettings = true;
  }

  LoadData() {

    this.Settings.MaxLimit = 100000;
    this.Settings.PDCRecGroupCA = 13;
    this.Settings.ItemTypeId = 1;
    this.Settings.CAType = 1;
    this.Settings.CompanyId = 1;
    this.Settings.LocationId = 1;
    this.Settings.BranchId = 1;
    this.Settings.GroupId = 1;
    this.Settings.NumberofDecimal = "1.2-2";
    this.Settings.PurchaseDefaultCashA = 1;
    this.Settings.PurchaseReturnVoucherType = "4";
    this.Settings.VatcollectedAcc = 8;
    this.Settings.VatPaidAcc = 9;
    this.Settings.VatEnabled = true;
    this.Settings.Itemwisevat = false;
    this.Settings.UserNo = 56;
    this.Settings.ItemmasterStartNo = 30000;
    this.Settings.BillPaymentVchr = 17;
    this.Settings.CashAccount = 1
    this.Settings.SupplierGrpID = 35;
    this.Settings.CustomerHead = 1;
    this.Settings.PDCPaymentGroupCA = 35;
    this.Settings.UserId = 1;
    this.Settings.SellingPriceLevelId = 1;
    this.Settings.CompanyName = "IPOS"
    this.Settings.BranchName = "IPOS"
    this.Settings.LocationName = "IPOS"
    this.Settings.BankHead = 13;
    this.Settings.AccountCreditNote = 6;
    this.Settings.AccountDebitNote = 7;
    this.Settings.CashHandHead = 11;
    this.Settings.TransferVchr = 30;
    this.Settings.CATypeId = 1;
    this.Settings.TaxVouchers;
    this.Settings.VATPersentage = 5.00;
    this.Settings.CCode = 1;
    this.Settings.RePackageVchr = 0;
    this.Settings.ProductionVchr = 0;
    this.Settings.ConsumptionAutoGenerate = false;
    this.Settings.IntegerPartCaption = "";
    this.Settings.DecimalPartCaption = "";
    this.Settings.Locationcollection = 1
    this.Settings.PDCReceiptGroupCA = 1;
    this.Settings.DefaultCashAccount = 1;
    this.Settings.DefaultCreditAccount = 1
    this.Settings.DefaultBankAccount = 1;
    this.Settings.InterBranchTrans = "30";
    this.LoadAllSettings();
    // this.LoadAccess(this.Settings.UserId);
  }
  LoadAccess(uid) {
    // this.Access["Item Master"] = { save: true, edit: true, delete: false, view: false, routerLink: "./inventory/products/product/product" }
    // this.Access["Purchase"] = { save: true, edit: true, delete: false, view: false, print: false, routerLink: "./inventory/purcahses" }
    // this.Access["Purchase Return"] = { save: true, edit: true, delete: false, view: false, print: false }
    // this.Access["Suppliers"] = { save: true, edit: true, delete: false, view: false }
    // this.Access["Customers"] = { save: true, edit: true, delete: false, view: false }
    // this.Access["Stock Adjustment"] = { save: true, edit: true, delete: false, view: false, print: false }
    // this.Access["GRN"] = { save: true, edit: true, delete: true, view: false, print: false }
    // this.Access["LPO"] = { save: true, edit: true, delete: true, view: false, print: false }
    // this.Access["Transfer"] = { save: true, edit: true, delete: false, view: false, print: false }
    // this.Access["Chart of Group"] = { save: true, edit: true, view: false }
    // this.Access["Product Group"] = { save: true, edit: true, delete: false, view: false }
    // this.Access["Account Transaction"] = { save: true, edit: false, delete: false, view: false, print: false }
    // this.Access["Tax Voucher"] = { save: true, edit: true, delete: false, view: false, print: false }
    // this.Access["Bill Payment"] = { save: true, edit: true, delete: true, view: false, print: false }
    // this.Access["Bill receipt"] = { save: true, edit: true, delete: true, view: false, print: false }
    // this.Access["Sales "] = { save: true, edit: true, delete: true, view: true, print: true }
    // this.Access["UserPrivileges"] = { save: true, edit: true, delete: true, view: true, print: true }
    // this.Access["Damage"] = { save: true, edit: true, delete: true, view: true, print: true }
    // this.Access["Consumption"] = { save: true, edit: true, delete: true, view: true, print: true }
    // this.Access["Re Packing"] = { save: true, edit: true, delete: true, view: true, print: true }
    // this.Access["Production"] = { save: true, edit: true, delete: true, view: true, print: true }
    // this.Access["SalesPosting"] = { save: true }
    // this.Access["Unit"] = { save: true, edit: true, delete: false }
    // this.Access["Brand"] = { save: true, edit: true, delete: false }
    // this.Access["Size"] = { save: true, edit: true, delete: false }
    // this.Access["Color"] = { save: true, edit: true, delete: true }
    // this.Access["SalesMan"] = { save: true, edit: true, delete: true }
    // this.Access["Reconciliation"] = { save: true }
    // this.Access["Cashier"] = { save: true, edit: true, delete: true }
    // this.Access["CounterS"] = { save: true, edit: true, delete: true }
    // this.Access["Loyalty Member"] = { save: true, edit: true, delete: false }
    // this.Access["Loyalty Card"] = { save: true, edit: true, delete: false }
    // this.Access["Point Updation"] = { save: true, edit: true, delete: false }
    // this.Access["Redemption"] = { save: true, edit: true, delete: false }
    // this.Access["Quotation"] = { save: true, edit: true, delete: false }
    // this.Access["Sales Order"] = { save: true, edit: true, delete: false }
    // this.Access["Delivery Note"] = { save: true, edit: true, delete: false }
    // this.Access["Sales Return"] = { save: true, edit: true, delete: false }
    // this.Access["Location"] = { save: true, edit: true, delete: true }
    // this.Access["Company"] = { save: true, edit: true, delete: false }
    // this.Access["Branch"] = { save: true, edit: true, delete: true }
    // this.Access["Menu Update"] = { save: true, edit: true, delete: false }
    // this.Access["GiftcardItem"] = { save: true, edit: true, delete: true }
    // this.Access["GiftCard"] = { save: true, edit: true, delete: true }
    // this.Access["Reasons"] = { save: true, edit: true, delete: true }
    // this.Access["Restaurant Settings"] = { save: true, edit: true, delete: false }
    // this.Access["Landing"] = { save: true, edit: true, delete: true }
    // this.Access["ItemBanner"] = { save: true, edit: true, delete: true }
    // this.Access["EcomLayout"] = { save: true, edit: true, delete: false }
    // this.Access["Product"] = { save: true, edit: true, delete: false }
    // this.Access["Taxonomy"] = { save: true, edit: true, delete: false }
    // this.Access["GLCodeMapping"] = { save: true, edit: true, delete: false }
    // this.Access["EcomRider"] = { save: true, edit: true, delete: true }
    // this.Access["EcomArea"] = { save: true, edit: true, delete: true }
    // this.Access["EcomState"] = { save: true, edit: true, delete: true }
    // this.Access["Material Requisitions"] = { save: true, edit: true, delete: true }
    // this.Access["Modifier Category"] = { save: true, edit: true, delete: true },
    //   this.Access["Rest TaxDetails"] = { save: true, edit: true, delete: true },
    //   this.Access["Giftcard Template"] = { save: true, edit: true, delete: true },
    //   this.Access["From Mails"] = { save: true, edit: true, delete: true },
    //   this.Access["Mails"] = { save: true, edit: true, delete: true },
    //   this.Access["Image Details"] = { save: true, edit: true, delete: true },
    //   this.Access["Inter Branch Transaction"] = { save: true, edit: true, delete: true },
    //   this.Access["Reservarion Shift"] = { save: true, edit: true, delete: true },
    //   this.Access["Blocked Hours"] = { save: true, edit: true, delete: true },
    //   this.Access["Reservation Room"] = { save: true, edit: true, delete: true },
    //   this.Access["Rest Info"] = { save: true, edit: true, delete: true },
    //   this.Access["Reservation Tags"] = { save: true, edit: true, delete: true },
    //   this.Access["Rest Messages"] = { save: true, edit: true, delete: true },
    //   this.Access["Rest Item Level"] = { save: true, edit: true, delete: true },
    //   this.Access["Rest ItemLevel Relation"] = { save: true, edit: true, delete: true },
    //   this.Access["Price Level"] = { save: true, edit: true, delete: true },
    //   this.Access["Transfer Approval"] = {},
    //   this.Access["Debit Note Distribution"] = { save: true, edit: true, delete: true },
    //   this.Access["SellingPriceBranchRelation"] = { save: true, edit: true, delete: true },
    //   this.Access["Denomination"] = { save: true, edit: true, delete: true },
    //   this.Access["Price Updation"] = { save: true, edit: true, delete: true },
    //   this.Access["Generate Item Relation"] = { save: true, edit: true, delete: true },
    //   this.Access["Sales Analysis Grid"] = { save: true, edit: true, delete: true },
    //   this.Access["Currency"] = { save: true, edit: true, delete: true },
    //   this.Access["Currency Master"] = { save: true, edit: true, delete: true },
    //   this.Access["Product Tool"] = { save: true, edit: true, delete: true },
    //   this.Access["Item Category Edit"] = { save: true, edit: true, delete: true },
    //   this.Access["POSGiftCard"] = { save: true, edit: true, delete: true },
    //   this.Access["Tax Voucher"] = { save: true, edit: true, delete: true },
    //   this.Access["Rest User Roles"] = { save: true, edit: true, delete: true },
    //   this.Access["Rest Roles"] = { save: true, edit: true, delete: true },
    //   this.Access["Printer Mapping"] = { save: true, edit: true, delete: true },
    //   this.Access["Course Type"] = { save: true, edit: true, delete: true },
    //   this.Access["Country"] = { save: true, edit: true, delete: true },
    //   this.Access["State"] = { save: true, edit: true, delete: true },
    //   this.Access["Online Payment Provider"] = { save: true, edit: true, delete: true },
    //   this.Access["Delivery Mgnt"] = { save: true, edit: true, delete: true },
    //   this.Access["Area Master"] = { save: true, edit: true, delete: true },
    //   this.Access["Backup Database"] = { save: true, edit: true, delete: true },
    //   this.Access["Excel Validation"] = { save: true, edit: true, delete: true },
    //   this.Access["Price Change"] = { save: true, edit: true, delete: false, routerLink: "" }
    // this.Access["Production Consumption"] = { save: true, edit: true, delete: true }
    // this.Access["Integration Info"] = { save: true, edit: true, delete: false }
    // this.Access["Item Integration"] = { save: true, edit: true, delete: true }
    // this.Access["Price Upload"] = { save: true, edit: true, delete: true }
    // this.Access["Mail Log"] = { save: true, edit: true, delete: true }
    // this.Access["Other Cards"] = { save: true, edit: true, delete: true }
    // this.Access["Approval List"] = { save: true, edit: true, delete: true }
    // this.Access["Room Printer Mapping"] = { save: true, edit: true, delete: true }
    // this.Access["DeptGiftVoucherSettings"] = { save: true, edit: true, delete: true }
    // this.Access["StyleCode Generation"] = { save: true, edit: true, delete: true }

    // this.Access["Buy X Get Y Promotion"] = { save: true, edit: true, delete: true }
    // this.Access["ItemwisePromotion"] = { save: true, edit: true, delete: true }
    // this.Access["MforXNforYPromotion"] = { save: true, edit: true, delete: true }

    // this.Access["Zatca Report"] = { save: true, edit: false, delete: false }

    var data = {
      CompanyId: this.Settings.CompanyId,
      LocationId: this.Settings.LocationId,
      BranchId: this.Settings.BranchId,
      UserId: uid
    }
    // this.GetAccessByUserId(data).subscribe(res => {
    //   // console.log(res);
    //   if (res.Success) {
    //     for (let i of res.data) {
    //       this.Access[i.From] = { save: i.Save, edit: i.Edit, delete: i.Delete, view: i.View, print: i.Print, routerLink: i.WebMenuUrl }
    //     }
    //     localStorage.setItem("Access_iPOSErp", JSON.stringify(this.Access))
    //     // console.log(localStorage.getItem("Access_iPOSErp"))
    //   }
    // })

    this.GetMenuAccessByUserId(data).subscribe(res => {
      // console.log(res);
      if (res.Success) {
        for (let i of res.data) {
          this.Access[i.From] = { save: i.Save, edit: i.Edit, delete: i.Delete, view: i.View, print: i.Print, routerLink: i.WebMenuUrl }
        }
        localStorage.setItem("Access_iPOSErp", JSON.stringify(this.Access))
        // console.log(localStorage.getItem("Access_iPOSErp"))
      }
    })
  }
  LoadAllSettings() {
    var data = {
      CompanyId: localStorage.getItem("CompanyId_" + environment.AppName),
      BranchId: localStorage.getItem("BranchId_" + environment.AppName),
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: 250,
        ItemTypeId: 1,
        CAType: 1
      }
    }
    this.GetSettings(data).toPromise().then(
      res => {
        if (res.Success) {
          for (let i of res.data) {
            this.Settings[i.PropertyName] = i.SettingsValue
            if (i.SettingsID == 3) {
              environment.noofdecimal = i.SettingsValue
            }
          }
          this.Settings.SellingPriceLevelId = localStorage.getItem("SellingPriceLevel" + environment.AppName)
          localStorage.setItem("Settings_" + environment.AppName + this.Settings.LocationId.toString(), JSON.stringify(this.Settings))
        }
      },
      error => {
        if (error.status == 401) {
          alert("Authentication failed");
          this.router.navigate(["/login"]);
        }
      }
    );
    this.resetSettings = false;
    this.LoadReportPermission()
  }
  LoadReportPermission() {
    var report: any = {
      CompanyId: this.Settings.CompanyId,
      BranchId: this.Settings.BranchId,
      LocId: this.Settings.LocationId,
      UserId: this.Settings.UserId
    }
    this.GetReportRights(report).subscribe(res => {
      if (res.Success) {
        if (res.data.length != 0) {
          localStorage.setItem("ReportSettings_" + environment.AppName, JSON.stringify(res.data))
        }
      }
    })
  }
  GetSettings(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetSettings",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSettingsByPropertyName(PropertyName) {
    var pdata = {
      CompanyId: this.Settings.CompanyId,
      PropertyName: PropertyName
    };
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetSettingsByPropertyName",
        pdata,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetProductSearch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ProductSearch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSupplierSearch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SupplierSearch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetAccessByUserId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetAccessByUserId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }
  GetMenuAccessByUserId(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetMenuAccessByUserId",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }
  GetItemSearch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Items",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetItemComboSearch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/rest/v1/Get_Items",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetReportRights(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetReportRights",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  RptReplacer(i, list): any {
    switch (i) {
      case "fromDate":
        var dates: Date = new Date();
        return new Date(dates.getFullYear(), dates.getMonth()).toDateString()
      case "FromDate":
        var dates: Date = new Date();
        return new Date(dates.getFullYear(), dates.getMonth()).toDateString()
      case "todate":
        return new Date().toDateString()
      case "toDate":
        return new Date().toDateString()
      case "ToDate":
        return new Date().toDateString()
      case "BranchId":
        return this.Settings.BranchId
      case "branchid":
        return this.Settings.BranchId
      case "company":
        return this.Settings.CompanyId
      case "location":
        return this.Settings.LocationId
      case "companyId":
        return this.Settings.CompanyId
      case "LocationId":
        return this.Settings.LocationId
      case "locid":
        return this.Settings.LocationId
      case "locationid":
        return this.Settings.LocationId
      case "companyid":
        return this.Settings.CompanyId
      case "locationIn":
        return this.Settings.LocationId
      case "companyIn":
        return this.Settings.CompanyId
      case "branchIn":
        return this.Settings.BranchId
    }
    for (let it in list) {
      if (it == i) {
        return list[it]
      }
    }
    return i;
  }


  loadItems() {
    this.ShowStockQtyInItemlist = false
    if (this.Settings && this.Settings.ShowStockQtyInItemlist) {
      var isx = (this.Settings.ShowStockQtyInItemlist)
      this.ShowStockQtyInItemlist = isx.toLowerCase() == 'true'
    }

    var FilterData: any = {
      SellingPricelevel: this.Settings.SellingPriceLevelId,
      Branch: this.Settings.BranchId,
      Location: this.Settings.LocationId,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: 15,
        ItemTypeId: 1,
        CAType: 1
      },
      FilterData: {
        Name: "",
        Barcode: "",
        RefNo: "",
        CostPrice: 0,
        SellingPrice: 0,
        SupplierName: "",
        Dept: "",
        Cat: "",
        SubCat: "",
        Unit: "",
        StkQty: 0
      },
      ShowStockQtyInItemlist: this.ShowStockQtyInItemlist
    };
    this.GetProductSearch(FilterData).subscribe(res => {
      if (res.Success) {
        this.ItemDetails = res;
        this.total = res.total;
      }
    }, (err) => { }, () => {
      this.loadItemsAfter(15);
    });
  }
  loadItemsAfter(Start: number) {
    var d = new Date();
    if (this.total > Start) {
      this.start = Start;
      this.ShowStockQtyInItemlist = false
      if (this.Settings && this.Settings.ShowStockQtyInItemlist) {
        var isx = (this.Settings.ShowStockQtyInItemlist)
        this.ShowStockQtyInItemlist = isx.toLowerCase() == 'true'
      }

      var FilterData: any = {
        SellingPricelevel: this.Settings.SellingPriceLevelId,
        Branch: this.Settings.BranchId,
        Location: this.Settings.LocationId,
        RequestedList: {
          Start: Number(this.start),
          FiterText: "",
          Limit: 5000,
          ItemTypeId: 1,
          CAType: 1
        },
        FilterData: {
          Name: "",
          Barcode: "",
          RefNo: "",
          CostPrice: 0,
          SellingPrice: 0,
          SupplierName: "",
          Dept: "",
          Cat: "",
          SubCat: "",
          Unit: "",
          StkQty: 0
        },
        ShowStockQtyInItemlist: this.ShowStockQtyInItemlist
      };
      this.GetProductSearch(FilterData).subscribe(res => {
        if (res.Success) {
          for (let i of res.data) {
            this.ItemDetails.data.push(i);
          }
          this.start = this.start + 5000
        }
      }, (err) => { }, () => {
        this.loadItemsAfter(this.start);
      });
    }
  }
  //---------------Rest-----------//
  GetRecipeItemSearch(FilterItems: any, type: boolean) {

    if (type) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsForRecipe",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/rest/v1/Get_ItemsInRecipe",
          FilterItems,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }

  }
  loadRestItems() {
    var FilterData: any = {
      RequestData: {
        Start: 0,
        FiterText: "",
        Limit: 10000,
        LocationId: this.Settings.LocationId
      },
      FilterData: {
        Name: "",
        ShortName: "",
        SellingPriceLevel: this.Settings.SellingPriceLevelId,
        UnitId: 0,
        SellingPrice: 0,
        CostPrice: 0,
        Barcode: "",
        PrinterName: "",
        ArabicName: "",
        ImagePath: ""
      }
    };
    this.GetItemSearch(FilterData).subscribe(res => {
      if (res.Success) {
        this.RestItemDetails = res;
      }
    }, (err) => { }, () => {
    });
  }
  loadRestItemcombo() {
    var FilterData: any = {
      RequestData: {
        Start: 0,
        FiterText: "",
        Limit: 15,
        LocationId: this.Settings.LocationId
      },
      FilterData: {
        ComboName: "",
        Price: 0
      }
    };
    this.GetItemComboSearch(FilterData).subscribe(res => {
      if (res.Success) {
        this.RestItemComboDetails = res;
        this.total = res.total;
      }
    }, (err) => { }, () => {
    });
  }
  loadRestItemsAfter(Start: number) {
    var FilterData: any = {
      RequestData: {
        Start: 0,
        FiterText: "",
        Limit: 15,
        LocationId: this.Settings.LocationId
      },
      FilterData: {
        Name: "",
        ShortName: "",
        SellingPriceLevel: this.Settings.SellingPriceLevelId,
        UnitId: 0,
        SellingPrice: 0,
        CostPrice: 0,
        Barcode: "",
        PrinterName: "",
        ArabicName: "",
        ImagePath: ""
      }
    };
    this.GetItemSearch(FilterData).subscribe(res => {
      if (res.Success) {
        for (let i of res.data) {
          this.RestItemDetails.data.push(i);
        }
        this.start = Number(FilterData.RequestedList.Limit)
      }
    }, (err) => { }, () => {
      //  this.loadRestItemsAfter(this.start);
    });
  }
  //---------------Rest-----------//

  CheckAndLoadSettings() {
    if (this.resetSettings) {
      this.Settings.LocationId = parseInt(localStorage.getItem("LocationId_" + environment.AppName))
      this.Settings.BranchId = parseInt(localStorage.getItem("BranchId_" + environment.AppName))
      this.Settings.CompanyId = parseInt(localStorage.getItem("CompanyId_" + environment.AppName))
      this.Settings.CompanyName = localStorage.getItem("CompanyName_" + environment.AppName)
      this.Settings.BranchName = localStorage.getItem("BranchName_" + environment.AppName)
      this.Settings.LocationName = localStorage.getItem("LocationName_" + environment.AppName)
      this.Settings.UserId = localStorage.getItem("UserId" + environment.AppName);
      this.DisplayName = localStorage.getItem("LocationName_" + environment.AppName)
      this.UserName = localStorage.getItem("userName" + environment.AppName)

      this.Settings.SellingPriceLevelId = Number(localStorage.getItem("SellingPriceLevel" + environment.AppName))
      this.Settings.ItemTypeId = Number(localStorage.getItem("ItemTypeId" + environment.AppName))
      this.Settings.CATypeId = Number(localStorage.getItem("CaTypeId" + environment.AppName))
      this.Settings = JSON.parse(localStorage.getItem("Settings_" + environment.AppName + this.Settings.LocationId.toString()))
      this.LoadAllSettings();
      this.LoadAccess(this.Settings.UserId);
      this.loadItems();
      this.loadRestItems();
      this.LoadReportPermission()
    }
  }
}
export interface ISettingProperty {
  PropertyName: string,
  SettingsValue: string,
  Result: boolean
}
export class SettingProperty_Model implements ISettingProperty {
  PropertyName: string;
  SettingsValue: string;
  Result: boolean;
  constructor() {
    this.PropertyName = "";
    this.SettingsValue = "";
    this.Result = false;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/data.service.ts